<template>
  <q-card style="width: 600px; max-width: 60vw;">
    <q-bar class="bg-primary text-white">
      <q-icon name="fas fa-keyboard" />
      <div>
        选择套餐项目
        <small class="q-ml-sm text-size-sm">
          <!-- {{ PdmBodycheckTaocanEntity.PdmBodycheckTaocanName }}({{
                            PdmBodycheckTaocanEntity.PdmBodycheckTaocanID
                        }}) -->
        </small>
      </div>

      <q-space />

      <q-btn dense flat icon="close" v-close-popup>
        <q-tooltip>关闭</q-tooltip>
      </q-btn>
    </q-bar>

    <q-card-section class="q-pa-sm">
      <div class="row q-gutter-sm q-mb-sm">
        <q-input
          outlined
          class="col-4"
          dense
          v-model="FilterString"
          label="项目名称"
          color="primary"
        />
        <q-btn
          color="primary"
          icon="search"
          @click="onLoadData"
          :loading="PdmBodycheckItemListLoading"
          style="height: 38px;"
        >
          查询
        </q-btn>
        <q-space />
        <!-- <q-btn color="primary" icon="download" style="height: 38px;" @click="onDownload" :loading="WxHomeimageListLoading">
                下载
              </q-btn>
              <q-btn color="primary" style="height: 38px" icon="fas fa-file-excel" :loading="PdmBodycheckItemListLoading" @click="onExportData">导出</q-btn> -->
        <!-- <q-btn
          color="primary"
          style="height: 38px"
          icon="note_add"
          :loading="PdmBodycheckItemListLoading"
          @click="onSyncItem"
          >同步项目</q-btn
        > -->
      </div>
      <vxe-grid
        ref="xGrid"
        v-bind="gridOptions"
        :sort-config="{ multiple: true }"
        :custom-config="{ storage: true }"
        id="custom-config"
        :export-config="gridOptions.tableExport"
        :height="550"
        :loading="PdmBodycheckItemListLoading"
        highlight-current-row
        size="mini"
        @checkbox-change="checkboxChangeEvent"
        @checkbox-all="checkboxChangeEvent"
      >
        <template #toolbar_buttons id="custom-config"> </template>
        <template #operate="{ row }">
          <vxe-button
            flat
            color="primary"
            icon="fas  fa-edit"
            @click="onEdit(row)"
            >编辑</vxe-button
          >
          <vxe-button
            flat
            color="negative"
            icon="fas fa-trash"
            @click="onDelete(row)"
            >删除</vxe-button
          >
        </template>
      </vxe-grid>
      <!-- <vxe-pager
        perfect
        size="mini"
        :page-sizes="tablePage.pageSizes"
        v-model:current-page="tablePage.currentPage"
        v-model:page-size="tablePage.pageSize"
        :total="tablePage.totalResult"
        :layouts="[
          'PrevPage',
          'JumpNumber',
          'NextPage',
          'FullJump',
          'Sizes',
          'Total',
        ]"
        @page-change="handlePageChange"
      >
      </vxe-pager> -->
    </q-card-section>

    <q-card-actions align="right" class="bg-white text-teal">
      <q-btn flat label="取消" v-close-popup />
      <q-btn flat label="确定" @click="onOK" />
    </q-card-actions>
  </q-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import XEUtils from "xe-utils";
import * as BodyCheckItem from "@/api/pdm/bodycheckItem";
import * as BodycheckTaocanitem from "@/api/pdm/bodycheckTaocanitem";
export default {
  components: {},
  computed: {
    ...mapState("PdmBodycheckItem", [
      "PdmBodycheckItemList",
      "PdmBodycheckItemListLoading",
      "PdmBodycheckItemEntity",
      "PdmBodycheckItemShowDlg",
    ]),
    ...mapState("PdmBodycheckTaocan", ["PdmBodycheckTaocanEntity"]),

    pdmBodycheckItemshowDlg: {
      get() {
        return this.PdmBodycheckItemShowDlg;
      },
      set(val) {
        console.log(val);
        this.$store.commit("PdmBodycheckItem/setPdmBodycheckItemShowDlg", val);
      },
    },
  },
  data() {
    return {
      FilterString: "",
      gridCheckboxList: [],
      tablePage: {
        currentPage: 1,
        pageSize: 20,
        totalResult: 0,
        pageSizes: [15, 20, 50, 100, 5000],
      },
      gridOptions: {
        border: true,
        resizable: true,
        showOverflow: true,
        highlightHoverRow: true,
        align: "left",
        toolbarConfig: {
          perfect: true,
          print: true,
          zoom: true,
          custom: true,
          export: true,
          slots: {
            // 自定义工具栏模板
            buttons: "toolbar_buttons",
          },
        },
        //点击编辑必须配置
        // editConfig: {
        //   trigger: "click",
        //   mode: "cell",
        //   activeMethod: () => {
        //     if (this.lockData) return false;
        //     return true;
        //   },
        // },
        tableExport: {},
        columns: [
          { type: "checkbox", width: 50, align: "left" },
          // {
          //   field: "HospName",
          //   title: "机构名称",
          //   sortable: true,
          //   align: "left",
          //   width: 160,
          // },
          {
            field: "Item_Code",
            title: "项目编码",
            sortable: true,
            align: "left",
            width: 100,
          },
          {
            field: "Item_Name",
            title: "项目名称",
            sortable: true,
            align: "left",
            width: 200,
          },
          // {
          //   field: "AddDate",
          //   title: "添加时间",
          //   sortable: true,
          //   align: "center",
          //   width: 160,
          // },
          // {
          //   title: "操作",
          //   width: 200,
          //   slots: { default: "operate" },
          //   align: "center",
          //   fixed: "right",
          // },
          //   {
          //     field: "CatName",
          //     title: "类别",
          //     sortable: true,
          //     editRender: { name: "input" },//点击编辑必须配置
          //     slots: { edit: "CatName" },//点击编辑必须配置
          //     align: "left",
          //     width: 140,
          //   },
        ],
        // data: this.PdmBodycheckItemList,
        data: null,
      },
    };
  },
  mounted() {
    this.onLoadData();
  },
  methods: {
    ...mapActions("PdmBodycheckItem", [
      "actGetPdmBodycheckItemListByPage",
      "actCreatePdmBodycheckItem",
      "actEditPdmBodycheckItemData",
      "actEditPdmBodycheckItem",
      "actDeletePdmBodycheckItem",
      "actGetPdmBodycheckItemList"
    ]),
    onLoadData() {
      this.actGetPdmBodycheckItemList({
        HospID: this.$store.getters["appUser/hospID"],
        CUser: this.$store.getters["appUser/userID"],
        FilterString: this.FilterString,
        TaoCan_ID: this.PdmBodycheckTaocanEntity.TaoCan_ID,
      })
        .then((res) => {
          this.gridOptions.data = res.Data;
          this.tablePage.totalResult = res.Count;
        })
        .finally(() => {
          this.$store.commit(
            "PdmBodycheckItem/setPdmBodycheckItemListLoading",
            false
          );
          //this.PdmBodycheckItemListLoading = false;
        });
    },
    onSyncItem() {
      BodyCheckItem.SyncItem({
        HospID: this.$store.getters["appUser/hospID"],
        CUser: this.$store.getters["appUser/userID"],
      })
        .then((res) => {
          if (res.Code == 0) {
            this.onLoadData();
            this.msg.success(res.Message);
          } else {
            this.msg.error(res.Message);
          }
        })
        .finally(() => {
          this.$store.commit(
            "PdmBodycheckItem/setPdmBodycheckItemListLoading",
            false
          );
        });
    },
    onOK() {
      BodycheckTaocanitem.UpdatePDM_BodyCheck_TaoCanItemEntity({
        HospID: this.$store.getters["appUser/hospID"],
        CUser: this.$store.getters["appUser/userID"],
        ItemList: this.gridCheckboxList,
        TaoCan_ID: this.PdmBodycheckTaocanEntity.TaoCan_ID,
      })
        .then((res) => {
          if (res.Code == 0) {
            //setTimeout(()=> {
            //this.$emit("onLoadData");
            //}, 500);
            this.$emit("onLoadTaoCanItem");
            this.msg.success(res.Message);
          } else {
            this.msg.error(res.Message);
          }
        })
        .finally(() => {
          this.$store.commit("PdmBodycheckTaocan/setTaocanItemShowDlg", false);
        });
    },
    onAdd() {
      this.actCreatePdmBodycheckItem({
        HospID: this.$store.getters["appUser/hospID"],
        CUser: this.$store.getters["appUser/userID"],
      });
    },
    onEdit(e) {
      var obj = {};
      Object.assign(obj, e);
      this.actEditPdmBodycheckItem(obj);
    },
    onDelete(e) {
      this.actDeletePdmBodycheckItem({
        HospID: this.$store.getters["appUser/hospID"],
        CUser: this.$store.getters["appUser/userID"],
        Info: e,
      }).then((res) => {
        if (res.Code == 0) {
          this.onLoadData();
        }
      });
    },
    //onExportData:{},
    //需要合计：表头必须添加 :footer-method="footerMethod" 跟 show-footer
    footerMethod({ columns, data }) {
      var list = ["PRIC"]; //需要汇总的字段
      const footerData = [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (list.includes(column.property)) {
            return XEUtils.sum(data, column.property);
          }
          return null;
        }),
      ];
      return footerData;
    },
    checkboxChangeEvent() {
      var grid = this.$refs.xGrid;
      var gridCheckbox = grid.getCheckboxRecords();

      this.gridCheckboxList = gridCheckbox;

      console.log("gridCheckboxList==>", this.gridCheckboxList);
    },
    handlePageChange({ currentPage, pageSize }) {
      this.tablePage.currentPage = currentPage;
      this.tablePage.pageSize = pageSize;
      this.onLoadData();
    },
  },
};
</script>
